import React, { useEffect, useState, Fragment } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

import { textForm, textFormDanhGia } from "../utils";

import theme from "../../../theme";
import KPTextform from "../../../components/KPTComponents/KPTextform";
import AnhChanDung from "../../../components/CommonComponents/AnhChanDung";
import { EDUCATE_DEGREE_CONSTANTS, FORM_MODEL_DANH_GIA } from "../../../constants";

function MucDanhGiaA9({ error, valueThamDinh, setValuesThamDinh, values,formThamDinh, handleChangeForm }) {
  // console.log('MucDanhGiaA9', values);
    // let textFormA9 = [];
    // const educateDegrees = values?.educateDegrees || [];
    // educateDegrees.forEach((item) => {
    //   const degreeType = item.degreeType;
    //   const degree = EDUCATE_DEGREE_CONSTANTS.TYPE_OPTIONS.find(
    //     (option) => option.key === degreeType
    //   )?.title;
    //   if (degree) {
    //     textFormA9.push({
    //       ...FORM_MODEL_DANH_GIA.thoiGianDaoTao,
    //       key: `${degreeType}`,
    //       label: `Bằng cấp ${degree}`,
    //       required: true,
    //       xs: 12,
    //     });
    //   }
    // });
  return (
    <Fragment>
      <Card style={{ width: '100%', marginTop: 16, backgroundColor: 'antiquewhite' }}>
        <CardContent>
        <Typography variant="h6" component="div" marginBottom={2}>
            {'Đánh giá của thẩm định'}
        </Typography>
          <Box display='flex'>
            <Box width='100%'>
              <KPTextform
                component={Box}
                error={error}
                values={valueThamDinh}
                setValues={setValuesThamDinh}
                textForm={formThamDinh?.mucA9 || []}
                handleChangeForm={handleChangeForm}
              />
            </Box>
          </Box>
          <Typography variant="inherit" component="div" marginTop={2} color={'rgb(211, 47, 47)'}>
              {'Vui lòng chọn một văn bằng phù hợp cho từng bậc học (bằng cách tích vào các ô "Xuất file" tương ứng) để xuất phiếu thẩm định (file 6A).'}
          </Typography>
        </CardContent>
      </Card>
    </Fragment>
  )
  
}

export default MucDanhGiaA9;